let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dqjVR")).then(() => parcelRequire('b2zWf'));